import type { ApiUser } from '~/types'

export function useAuth() {
    const { loggedIn, user, fetch: refreshSession, clear } = useUserSession()

    const currentUser = computed(() => user.value as ApiUser | null)

    async function login(email: string, password: string): Promise<void> {
        await $fetch('/api/auth/login', { method: 'POST', body: { email, password } })
        await refreshSession()
    }

    async function register(payload: {
        name: string
        email: string
        password: string
        password_confirmation: string
    }): Promise<void> {
        await $fetch('/api/auth/register', { method: 'POST', body: payload })
        await refreshSession()
    }

    async function logout(): Promise<void> {
        await $fetch('/api/auth/logout', { method: 'POST' })
        // Clear PWA caches so next user doesn't get stale data offline
        try {
            const keys = await caches.keys()
            await Promise.all(keys.map(k => caches.delete(k)))
        } catch { /* Cache API may not be available */ }
        await clear()
        await navigateTo('/')
    }

    async function refreshUser(): Promise<void> {
        await $fetch('/api/auth/refresh-user', { method: 'POST' })
        await refreshSession()
    }

    return { loggedIn, user: currentUser, login, register, logout, refreshUser, refreshSession }
}
